/**
 * Created by Administrador on 05/01/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('calculationTypeService', calculationTypeService);

    calculationTypeService.$inject = ['$http', 'CONFIG', 'messageService'];

    function calculationTypeService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FARE_CONTROL + '/' + CONFIG.API + '/calculationTypes';
        var service = {
            getCalculationTypes: getCalculationTypes,
        }

        return service;

        function getCalculationTypes(){
            return $http.get(urlBase)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }
    };

})();
